import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex min-h-0 flex-1 flex-col"
}
const _hoisted_2 = { class: "flex h-full min-h-0 w-full flex-1 flex-col overflow-x-hidden overflow-y-auto" }
const _hoisted_3 = { class: "grid flex-1 gap-1.5 md:grid-cols-2" }

import AppLayout from '@/layouts/AppLayout.vue';
    import PageCard from '@/components/PageCard.vue';
    import { Head } from '@inertiajs/vue3';
    import { Company } from '@/types';
    import CustomerDashboardBanner from '@/components/customer-dashboard/CustomerDashboardBanner.vue';
    import CustomerDashboardTasks from '@/components/customer-dashboard/CustomerDashboardTasks.vue';
    import CustomerDashboardProcedures from '@/components/customer-dashboard/CustomerDashboardProcedures.vue';
    import PowerBI from '@/components/PowerBI.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboard',
  props: {
    company: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('dashboards.title')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: [],
      "hide-header": "",
      "require-selected-company": "",
      "content-class": "overflow-hidden"
    }, {
      default: _withCtx(() => [
        (_ctx.company)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(CustomerDashboardBanner, { company: _ctx.company }, null, 8, ["company"]),
                (_unref(hasPermission)(_unref(Permission).POWERBI_VIEW) && _ctx.company.services.has_power_bi)
                  ? (_openBlock(), _createBlock(PageCard, {
                      key: 0,
                      class: "mb-0 h-auto flex-none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(PowerBI)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(CustomerDashboardTasks, { company: _ctx.company }, null, 8, ["company"]),
                  _createVNode(CustomerDashboardProcedures, { company: _ctx.company }, null, 8, ["company"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})